import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { GeneralModule } from './general/general.module';
import { EspeciesModule } from './especies/especies.module';
import { FrecuenciaReducidaModule } from './frecuenciareducida/frecuenciareducida.module';
import { UsuariosModule } from './usuarios/usuarios.module';
import { InformesModule } from './informes/informes.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegistrosModule } from './registros/registros.module';
import { EnviosModule } from './envios/envios.module';
import { PermisosModule } from './permisos/permisos.module';
import { CampaniasMtoModule } from './campanias/campaniasMto.module';
import { AlertasModule } from './alertas/alertas.module';

@NgModule({
    declarations: [],
    imports: [
        AlertasModule,
        GeneralModule,
        EspeciesModule,
        EnviosModule,
        CampaniasMtoModule,
        FrecuenciaReducidaModule,
        InformesModule,
        RegistrosModule,
        UsuariosModule,
        PermisosModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class MantenimientoModule {}
